import React, { useState } from 'react';
import { Button, ButtonGroup, Grid, Typography } from '@mui/material';
import DailyWindows from './DailyWindows';

function Windows({ name, days, props: { label, buttonLabel, required, noLabel = false } }) {
    const [currentDay, setCurrentDay] = useState(0);

    return (
        <>
            <ButtonGroup variant="outlined" sx={{ my: 1 }}>
                {days.map((day, index) => (
                    <Button
                        key={day}
                        onClick={() => setCurrentDay(index)}
                        variant={index === currentDay ? 'contained' : 'outlined'}
                        // wrap
                    >
                        {day.substring(0, 3)}
                    </Button>
                ))}
            </ButtonGroup>
            <Typography
                sx={{ my: 2 }}
                variant="body1"
                fontWeight="bold"
                // wrap
            >
                {days[currentDay]} Schedule
            </Typography>
            <Grid sx={{ border: (th) => `1px solid ${th.palette.divider}`, borderRadius: '4px', padding: 2 }}>
                {!noLabel && (
                    <Typography
                        sx={{ mb: 1 }}
                        variant="body2"
                        fontWeight="bold"
                        // wrap
                    >
                        {`${label}${required ? '*' : ''}`}
                    </Typography>
                )}
                {days.map((_day, index) => (
                    <DailyWindows
                        key={_day}
                        name={`${name}[${index}]`}
                        buttonLabel={buttonLabel ?? label}
                        show={index === currentDay}
                        //
                    />
                ))}
            </Grid>
        </>
    );
}

export default Windows;
